import React, { useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { Sphere, MeshDistortMaterial, Float } from '@react-three/drei';

const AbstractOrb = () => {
  const orbRef = useRef();
  const ring1Ref = useRef();
  const ring2Ref = useRef();

  useFrame((state) => {
    const t = state.clock.getElapsedTime();
    orbRef.current.rotation.y = t * 0.2;
    ring1Ref.current.rotation.x = t * 0.5;
    ring1Ref.current.rotation.z = t * 0.3;
    ring2Ref.current.rotation.y = t * 0.4;
    ring2Ref.current.rotation.z = t * 0.2;
  });

  return (
    <group>
      {/* Central Orb */}
      <Float speed={2} rotationIntensity={1} floatIntensity={2}>
        <Sphere ref={orbRef} args={[1, 64, 64]}>
          <MeshDistortMaterial
            color="#D4AF37"
            speed={2}
            distort={0.4}
            radius={1}
            emissive="#554400"
            emissiveIntensity={0.5}
            roughness={0.1}
            metalness={0.9}
          />
        </Sphere>
      </Float>

      {/* Futuristic Data Rings */}
      <mesh ref={ring1Ref} rotation={[Math.PI / 2, 0, 0]}>
        <torusGeometry args={[1.6, 0.02, 16, 100]} />
        <meshStandardMaterial color="#F8E282" emissive="#D4AF37" emissiveIntensity={2} />
      </mesh>

      <mesh ref={ring2Ref} rotation={[0, Math.PI / 4, 0]}>
        <torusGeometry args={[1.4, 0.015, 16, 100]} />
        <meshStandardMaterial color="#AA8A1E" emissive="#AA8A1E" emissiveIntensity={2} transparent opacity={0.6} />
      </mesh>

      {/* Glowing core light */}
      <pointLight position={[0, 0, 0]} intensity={3} color="#D4AF37" />
    </group>
  );
};

const ThreeScene = () => {
  return (
    <div className="w-full h-full min-h-[400px]">
      <Canvas camera={{ position: [0, 0, 5], fov: 45 }}>
        <ambientLight intensity={0.5} />
        <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} intensity={1.5} color="#F8E282" />
        <pointLight position={[-10, -10, -10]} color="#AA8A1E" />
        <AbstractOrb />
      </Canvas>
    </div>
  );
};

export default ThreeScene;
